//animation
$(function(){

  //top以外は無視
  if ($('body').hasClass('lowerpage')) {
    return false;
  }

  // セッションストレージ確認
  var animeShow = window.sessionStorage.getItem('animeShow');
  if ( animeShow ) {
    $('.op0').removeClass('op0');
    $('#loading').fadeOut(200,function(){
      sakuraFall();
    });
    return false;
  }

  //vars
  var $win = $(window);
  var $kv = $('#kv');
  var scrollElm = (function () { //chrome対策
    if ('scrollingElement' in document) {
      return document.scrollingElement;
    }
    if (navigator.userAgent.indexOf('WebKit') != -1) {
      return document.body;
    }
    return document.documentElement;
  })();

  $win.on('mousewheel.opening', function(){
    return false; //Disable Mousewheel
  });

  //chrome対策
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual'; //scroll位置消す
  }

  var winPosFix = false;
  var kvH = $kv.offset().top + $kv.innerHeight();
  var winH = $win.height();
  if (winH < kvH) {
    winPosFix = true; //flag on
    var posY = (kvH - winH);
    if (posY < 0) {
      posY = 0;
    }
    $(scrollElm).scrollTop(posY);
  }


  function a2() {
    var tl = new TimelineMax();
    tl.add( TweenLite.set('#loading-logo', {y: 16}));
    // tl.add( TweenLite.set('#objs-left', {top: -8}) );
    // tl.add( TweenLite.set('#objs-right', {top: -8}) );
    // tl.add( TweenLite.set('#mainnav', {y: -8}) );
    return tl;
  }
  a2();


  function a3() {
    var tl = new TimelineMax({delay:0.4});
    tl.add( TweenLite.to('#objs-left', 0.8, {opacity:1, top:0}), 0 );
    tl.add( TweenLite.to('#objs-right', 0.8, {opacity:1, top:0}), 0.8 );
    tl.add( TweenLite.to('#mainnav', 0.8, {opacity:1, y: 0}), 1.6 );
    tl.add( function(){
      $('.op0').removeClass('op0');
    }, 2.4 );
    tl.add( sakuraFall, 2.4 );
    return tl;
  }

  function a4() {
    var tl = new TimelineMax();
    tl.add( TweenLite.to('#loading-logo', 0.8, {opacity:1, y: 0, ease: Sine.easeInOut}), 0.2 );
    tl.add( showLoading, 2.4 );
    return tl;
  }

  function showLoading () {

    $('#loading').fadeOut(600,function(){
      if (winPosFix) {
        //scroll window
        $(scrollElm).delay(400).animate({
          scrollTop: 0
        }, 1600, 'easeInOutQuad', function(){
          $win.off('mousewheel.opening'); //Enable Mousewheel
          a3(); //show element
          window.sessionStorage.setItem('animeShow',true);
        });
      } else {
        $win.off('mousewheel.opening'); //Enable Mousewheel
        a3(); //show element
        window.sessionStorage.setItem('animeShow',true);
      }
    });
  }


  $(window).on('load',function(){

    a4();

  })


});
